/** Ajutoare Ultra: badge de status job. */
import type { UltraJobStatus } from '@reclame-ai/shared';
import { Pill } from './ui';

const LABEL: Record<UltraJobStatus, string> = {
  nou: 'Comandat',
  in_lucru: 'Editor lucrează',
  livrat: 'Livrat de editor',
  revizie: 'În revizie',
  finalizat: 'Finalizat',
};

export function UltraStatusBadge({ status }: { status: UltraJobStatus }) {
  const tone = status === 'finalizat' ? 'ok' : status === 'livrat' ? 'warn' : status === 'revizie' ? 'warn' : 'accent';
  return <Pill tone={tone}>{LABEL[status]}</Pill>;
}

export const ULTRA_TIMELINE: { status: UltraJobStatus[]; label: string }[] = [
  { status: ['nou'], label: 'Comandat' },
  { status: ['in_lucru', 'revizie'], label: 'Editor lucrează' },
  { status: ['livrat'], label: 'Livrat — review' },
  { status: ['finalizat'], label: 'Finalizat' },
];
